import React, { Component } from "react";
import Button from "components/UI/Button";
import Box from "components/UI/Box";
import SearchBox from "components/SearchBox";
import SlideSwitch from "components/SlideSwitch";
import CollapsableRow from "components/CollapsableRow";
import Spinner from 'components/LoadingSpinner'
import Pagination from "components/Pagination";
import axios from "axios";
import { cacheAdapterEnhancer, throttleAdapterEnhancer } from 'axios-extensions';
import { alert, sortArrayByGivenKey } from '../../../../common/Utils'
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import {
  API_URL,
  ERROR_HANDLE,
  DOWNLOAD,
  PERSIST_GYMS,
  PERSIST_GYMS_SEARCH_QUERY,
  PERSIST_GYMS_CURRENT_PAGE,
  PERSIST_GYMS_COUNT_PER_PAGE
} from "config/constants";
import EditModal from "../Modals/EditModal";
import { isNumber } from "util";
import { validateTime, validatePhone } from '../../../../common/Utils'
import { Constants } from "../../../../common/constants";

const access_level = localStorage.getItem("access_level");
const MIGRATE_TEXT = "Migrate"
const ALERT_TEXT_SUCCESS_COUNT = "Updated success count: "
const ALERT_TEXT_FAILURE_COUNT = "Updated fail count: "

const EXPORT_TEXT = "Export"
const PROMOTIONAL_OFFERS_TEXT = "Promotional Offers"
const GYM_TAGS_TEXT = "Gym Tags"

const instance = axios.create({
  baseURL: API_URL,
  adapter: throttleAdapterEnhancer(cacheAdapterEnhancer(axios.defaults.adapter))
});

class Gyms extends Component {
  constructor(props) {
    super(props);
    var page = localStorage.getItem(PERSIST_GYMS_CURRENT_PAGE) ? parseInt(localStorage.getItem(PERSIST_GYMS_CURRENT_PAGE)) : 0
    var count = localStorage.getItem(PERSIST_GYMS_COUNT_PER_PAGE) ? parseInt(localStorage.getItem(PERSIST_GYMS_COUNT_PER_PAGE)) : Constants.DEFAULT_PAGINATION_COUNT
    this.state = {
      gyms: [],
      filteredGyms: [],
      currentPage: page,
      isLoading: false,
      showEdit: false,
      rowCount: count,
      sort: "name",
      ascending: true
    };
    this.toggledGymId = null;
  }

  componentDidMount() {
    this.getGyms();
  }

  header = () => {
    return (
      <div style={style.titleWrapper}>{
        labels.map((label, i) => {
          let titleItem = label.label === "Profile" ? style.titleItemBig : style.titleItemSmall;
          let { sort, ascending, filteredGyms, gyms } = this.state
          return (
            <div style={titleItem} key={i} onClick={()=>{
              if(filteredGyms && filteredGyms.length > 0 && label.sortable) {
                let sortedAndFilteredGyms = sortArrayByGivenKey(filteredGyms, label.key, ascending)
                let sortedGyms = sortArrayByGivenKey(gyms, label.key, ascending)
                this.setState({
                  filteredGyms: sortedAndFilteredGyms,
                  gyms: sortedGyms,
                  sort: label.key,
                  ascending: !ascending
                })
              }
            }}>
              <p>{label.label}</p>
              {
                label.sortable &&
                <div style={{marginLeft:'10px'}}>
                  <p style={{margin:0, fontSize:'10px'}}>{sort === label.key && !ascending ? '\u25B2' : '\u25B3'}</p>
                  <p style={{margin:0, fontSize:'10px'}}>{sort === label.key && ascending ? '\u25BC' : '\u25BD'}</p>
                </div>
              }
            </div>
          );
        })}
      </div>
    )
  };

  searchHandler(gyms, query) {
    if (gyms && gyms.length > 0)
      return gyms.filter(gym => {
        const gymName = gym.gym_name;
        return gym.gym_name && gymName.toLowerCase().includes(query) > 0
      });
    else return gyms;
  }

  getGyms() {
    const access_token = localStorage.getItem("access_token");
    const toastId = toast("Fetching Gyms...");

    instance.get('/admin/gyms/basicDetails', {
      headers: {
        "x-access-token": access_token,
      }
    })
      .then(res => {
        toast.dismiss(toastId);
        var query = localStorage.getItem(PERSIST_GYMS_SEARCH_QUERY);
        var filteredGyms = res.data
        if (query) {
          filteredGyms = this.searchHandler(filteredGyms, query);
        }
        this.setState({
          ...this.state,
          gyms: res.data,
          filteredGyms
        });
      })
      .catch(err => {
        ERROR_HANDLE(err);
      });
  }

  exportAllGyms = () => {
    const access_token = localStorage.getItem("access_token");
    const toastId = toast("Exporting Gyms Data...");
    axios
      .get(`${API_URL}/admin/export/gyms`, {
        headers: {
          "x-access-token": access_token
        }
      })
      .then(res => {
        DOWNLOAD(res.data, "export.csv");
        toast.dismiss(toastId);
      })
      .catch(err => {
        ERROR_HANDLE(err);
      });
  };

  updateGymActiveState(activeState) {
    const toastId = toast("Updating Gym Active State...");
    const access_token = localStorage.getItem("access_token");
    axios
      .post(
        `${API_URL}/admin/gyms/changeStatus/${this.toggledGymId}`,
        {
          status: activeState
        },
        {
          headers: {
            "x-access-token": access_token
          }
        }
      )
      .then(res => {
        toast.dismiss(toastId);
        toast("Status Changed Successfully", { autoClose: 1500 });
        this.toggledGymId = null;
      })
      .catch(err => {
        this.updateToggleState(this.toggledGymId);
        this.toggledGymId = null;
        toast.dismiss(toastId);
        setTimeout(() => {
          ERROR_HANDLE(err);
        }, 500);
      });
  }

  updateGymPTEnablement(activeState) {
    const toastId = toast("Updating Gym PT Enablement...");
    const access_token = localStorage.getItem("access_token");
    axios
      .post(
        `${API_URL}/admin/gyms/changeTrainerEnablement/${this.toggledGymId}`,
        {
          status: activeState
        },
        {
          headers: {
            "x-access-token": access_token
          }
        }
      )
      .then(res => {
        toast.dismiss(toastId);
        toast("PT Status Changed Successfully", { autoClose: 1500 });
        this.toggledGymId = null;
      })
      .catch(err => {
        this.updateTogglePTState(this.toggledGymId);
        this.toggledGymId = null;
        toast.dismiss(toastId);
        setTimeout(() => {
          ERROR_HANDLE(err);
        }, 500);
      });
  }

  handleSlideSwitch = (activeState) => {
    if (this.toggledGymId) {
      this.updateToggleState(this.toggledGymId);
      this.updateGymActiveState(activeState)
    }
  };

  handlePTSlideSwitch = (activeState) => {
    if (this.toggledGymId) {
      this.updateTogglePTState(this.toggledGymId);
      this.updateGymPTEnablement(activeState)
    }
  };

  updateToggleState(toggledGymId) {
    this.setState(prevState => ({
      filteredGyms: prevState.filteredGyms.map(
        gyms => gyms.gym_id === toggledGymId ? { ...gyms, is_available: !gyms.is_available } : gyms
      )
    }))
  }

  updateTogglePTState(toggledGymId) {
    this.setState(prevState => ({
      filteredGyms: prevState.filteredGyms.map(
        gyms => gyms.gym_id === toggledGymId ? { ...gyms, is_trainer_enabled: !gyms.is_trainer_enabled } : gyms
      )
    }))
  }

  generateTimeZone = () => {
    const access_token = localStorage.getItem("access_token");
    const toastId = toast("Generating Time Zone...");
    axios
      .get(`${API_URL}/admin/generateTimezone`, {
        headers: {
          "x-access-token": access_token
        }
      })
      .then(res => {
        toast.dismiss(toastId);
        let alertMessage = ""
        if (res.data.updatedCount) {
          alertMessage = ALERT_TEXT_SUCCESS_COUNT + res.data.updatedCount;
        }
        if (res.data.updateFailedCount) {
          alertMessage = alertMessage + ALERT_TEXT_FAILURE_COUNT + res.data.updateFailedCount;
        }
        alert(alertMessage)
      })
      .catch(err => {
        toast.dismiss(toastId);
        setTimeout(() => {
          ERROR_HANDLE(err);
        }, 500);
      });
  };

  updateGymAttribute = () => {
    this.setState({ isLoading: true })
    const access_token = localStorage.getItem("access_token");
    axios
      .get(`${API_URL}/admin/updateGymAttributes`, {
        headers: {
          "x-access-token": access_token
        }
      })
      .then(res => {
        this.setState({ isLoading: false });
        let alertMessage = ""
        if (res.data.updatedCount) {
          alertMessage = ALERT_TEXT_SUCCESS_COUNT + res.data.updatedCount;
        }
        if (res.data.updateFailedCount) {
          alertMessage = alertMessage + ALERT_TEXT_FAILURE_COUNT + res.data.updateFailedCount;
        }
        alert(alertMessage)
      })
      .catch(err => {
        this.setState({ isLoading: false });
        setTimeout(() => {
          ERROR_HANDLE(err);
        }, 500);
      });
  };

  render() {
    const acl = localStorage.getItem("restricted_access");
    const rowCount = parseInt(this.state.rowCount)
    return (
      <div style={style.wrapper}>
        <SearchBox
          value={localStorage.getItem(PERSIST_GYMS_SEARCH_QUERY)}
          onChange={(e) => {
            var query = e.target.value.toLowerCase();
            localStorage.setItem("searchQuery", query)
            var filteredGyms = this.searchHandler(this.state.gyms, query)
            //Move the current page to 1, when start searching
            this.setState({ ...this.state, filteredGyms, currentPage: 0 });
            localStorage.setItem("currentGymPage", 0)

          }}>
          {/* <div style={style.locationDropdownWrapper}>
            <img
              style={style.dropdownIcon}
              src={require("assets/images/crosshair-white-nobg.png")}
              alt="Location"
            />
            <Select options={locationOptions} styles={style.locationDropdown} />
          </div> */}
          <div style={{ width: "20px" }} />
          {/* <Link to="/gyms/export"> */}
          {access_level == Constants.ADMIN_ACCESS_LEVELS.TIER_2 ? null :
            <div>
              {acl === "false" ? <Button
                style={style.exportButton}
                type="primary"
                onClick={this.exportAllGyms}
              >
                {EXPORT_TEXT}
              </Button>
                : null}
            </div>
          }
          {acl === "false" ?
            <Link to="/gyms/PromotionalOffers/">
              <Button
                style={style.promotionalOffersButton}
                type="primary"
              >
                {PROMOTIONAL_OFFERS_TEXT}
              </Button>
            </Link>
            : null}
          {acl === "false" ?
            <Link to="/gyms/GymTags/">
              <Button
                style={style.gymTagsButton}
                type="primary"
              >
                {GYM_TAGS_TEXT}
              </Button>
            </Link>
            : null}
          {/* {acl === "false" ? <Button
            style={style.migrateButton}
            type="primary"
            onClick={() => this.updateGymAttribute()}
          >
            {MIGRATE_TEXT}
          </Button>
            : null} */}
          {/* </Link> */}
        </SearchBox>
        <Box style={style.box} outline>
          {this.header()}
          {this.gymRows(this.state.filteredGyms).map((currentItem, i) =>
            // <CollapsableRow data={currentItem} key={i} />
            i >= this.state.currentPage * rowCount &&
              i < this.state.currentPage * rowCount + rowCount ? (
                <CollapsableRow data={currentItem} key={i} />
              ) : (
                ""
              )
          )}
        </Box>
        <Pagination
          currentPage={this.state.currentPage}
          pageCount={this.state.filteredGyms.length / rowCount}
          rowCount={rowCount}
          pageAction={pageNumber => {
            localStorage.setItem("currentGymPage", pageNumber)
            this.setState({ ...this.state, currentPage: pageNumber });
          }}
          updateRowCount={(rowCount) => {
            localStorage.setItem("currentGymPage", 0)
            localStorage.setItem(PERSIST_GYMS_COUNT_PER_PAGE, rowCount)
            this.setState({ rowCount, currentPage: 0 })
          }}
        />
        <Spinner message="Updating Gyms..." loading={this.state.isLoading} />
        {/* <UserModal/> */}
        {this.state.showEdit &&
          <EditModal gym={this.state.selectedGym} close={() => {
            this.setState({
              showEdit: false
            })
          }} />
        }
      </div >
    );
  }

  gymRows = gyms =>
    gyms.map((currentItem, i) => {
      const style = {
        itemWrapper: {
          display: "flex",
          width: "100%",
          alignItems: "center"
        },
        item: {
          flex: 1,
          alignSelf: "center",
        },
        sliderStyle: {
          alignSelf: "center",
          flex: 1,
          marginTop: 5,
          minWidth: 75
        },
        buttonWrapper: {
          flex: 2,
          justifyContent: "center",
          alignItems: "center"
        },
        button: {
          width: "77px",
          height: "29px",
          fontSize: "16px",
          color: "#414141"
        },
        collapsableWrapper: {
          backgroundColor: "#000",
          color: "#b5b5b6",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "10px 0px"
        },
        collapseLabel: {
          fontSize: "10px"
        },
        collapseItem: {
          margin: "0px"
        }
      };
      let address = "";
      if (currentItem.address) address = currentItem.address;

      let persistent = (
        <div>
          <hr style={{ borderTop: "1px solid #b5b5b6", borderRadius: "0.5px" }} />

          <div style={style.itemWrapper}>
            <p style={{ ...style.item }}>{currentItem.gym_name}</p>
            <p style={{ ...style.item }}>{currentItem.gym_id}</p>
            <p style={{ ...style.item }}>{currentItem.city}</p>
            <p style={{ ...style.item }}>{currentItem.state}</p>
            <SlideSwitch
              style={style.sliderStyle}
              checked={currentItem.is_available}
              onClick={() => {
                this.toggledGymId = currentItem.gym_id
                this.handleSlideSwitch(!currentItem.is_available)
              }}
            />
            <p style={{ ...style.item }}>{validatePhone(currentItem.phone)}</p>
            <SlideSwitch
              style={style.sliderStyle}
              checked={currentItem.is_trainer_enabled}
              onClick={() => {
                this.toggledGymId = currentItem.gym_id
                this.handlePTSlideSwitch(!currentItem.is_trainer_enabled)
              }}
            />
            {/* <p style={{ ...style.item }}>{currentItem.session}</p> */}
            <div
              style={style.buttonWrapper}
            >
              <Link
                to={{
                  pathname: "/gyms/gym/facilities",
                  state: { gym_id: currentItem.gym_id, gym: currentItem }
                }}
              >
                <Button
                  type="holo"
                  holo
                  style={{ ...style.button }}
                  onClick={() => {
                    localStorage.setItem("currentGymID", currentItem.gym_id);
                  }}
                >
                  View
              </Button>
              </Link>
              <Button
                type="holo"
                holo
                style={{ ...style.button, marginLeft: 10 }}
                onClick={(e) => {
                  e.stopPropagation()
                  this.setState({
                    showEdit: true,
                    selectedGym: currentItem
                  })
                }}>
                Edit
              </Button>
            </div>
          </div>
        </div>
      );

      let collapsable = (
        <div style={style.collapsableWrapper}>
          <div style={style.itemWrapper}>
            <p style={{ ...style.item, ...style.collapseItem }}>
              {currentItem.gym_name && currentItem.gym_name.toUpperCase()}
            </p>
            <div style={{ ...style.item }}>
              <img
                src={require("assets/images/address.png")}
                alt="Address"
                width="35px"
              />
              <p style={{ ...style.item, ...style.collapseLabel }}>ADDRESS</p>
              <p style={{ ...style.item, ...style.collapseItem }}>
                {address}
                {address.length > 21 && address.length < 46 ? (
                  <React.Fragment>
                    <br />
                    &nbsp;
                </React.Fragment>
                ) : address.length < 30 ? (
                  <React.Fragment>
                    <br />
                    &nbsp;
                  <br />
                    &nbsp;
                </React.Fragment>
                ) : (
                      " "
                    )}
              </p>
            </div>
            <div style={{ ...style.item }}>
              <img
                src={require("assets/images/price.png")}
                alt="Price"
                width="35px"
              />
              <p style={{ ...style.item, ...style.collapseLabel }}>RATE</p>
              <p style={{ ...style.item, ...style.collapseItem }}>
                {isNumber(currentItem.rate) ? `$ ${parseFloat(currentItem.rate).toFixed(2, 10)}/min` : "-"}
                <br />
                {isNumber(currentItem.rate) && `($ ${(parseFloat(currentItem.rate) * 60).toFixed(2, 10)}/hr)`}
                <br />
                &nbsp;
            </p>
            </div>
            <div style={{ ...style.item }}>
              <img
                src={require("assets/images/clock.png")}
                alt="Gym Hours"
                width="35px"
              />
              <p style={{ ...style.item, ...style.collapseLabel }}>GYM HOURS</p>
              <p style={{ ...style.item, ...style.collapseItem }}>
                {`${validateTime(currentItem.working_hours.start)} - ${
                  validateTime(currentItem.working_hours.end)
                  }`}
                <br />
                &nbsp;
              <br />
                &nbsp;
            </p>
            </div>
            {/* <div style={{ ...style.item }}>
            <img src={require("assets/images/distance.png")} alt="Distance" />
            <p style={{ ...style.item, ...style.collapseLabel }}>DISTANCE</p>
            <p style={{ ...style.item, ...style.collapseItem }}>
              {currentItem.distance}
            </p>
          </div> */}
            <div style={{ ...style.item }}>
              <img
                src={require("assets/images/emergency.png")}
                alt="Contact"
                width="35px"
              />
              <p style={{ ...style.item, ...style.collapseLabel }}>CONTACT</p>
              <p style={{ ...style.item, ...style.collapseItem }}>
                {validatePhone(currentItem.phone)}
                <br />
                {currentItem.email}
                <br />
                &nbsp;
            </p>
            </div>
            <div />
          </div>
        </div>
      );

      return { persistent: persistent, collapsable: collapsable };
    });
}
export default Gyms;

const labels = [
  {
    label: "Name",
    key: "gym_name",
    sortable: true
  },
  {
    label: "Id",
    key: "gym_id",
    sortable: false,
  },
  {
    label: "City",
    key: "city",
    sortable: true
  },
  {
    label: "State",
    key: "state",
    sortable: true,
  },
  {
    label: "Active",
    key: "is_available",
    sortable: true
  },
  {
    label: "Phone",
    key: "phone",
    sortable: false
  },
  {
    label: "PT",
    key: "is_trainer_enabled",
    sortable: true
  },
  {
    label: "Profile",
    key: "profile",
    sortable: false
  }
];

const style = {
  titleWrapper: {
    display: "flex",
    flex: 1
  },
  titleItemSmall: {
    display:'flex',
    flex: 1,
    flexDirection:'row',
    fontSize: "20px",
    color: "#00b4d2",
    alignItems:'center',
    justifyContent:'center'
  },
  titleItemBig: {
    flex: 2,
    fontSize: "20px",
    color: "#00b4d2",
  },
  box: {
    width: "900px"
  },
  wrapper: {
    display: "flex",
    justifyContent: "center",
    marginTop: "10px",
    flexDirection: "column",
    alignItems: "center"
  },
  locationDropdown: {
    container: (base, state) => ({
      ...base,
      width: "200px",
      margin: "0px 10px"
    }),
    valueContainer: (base, state) => ({
      ...base,
      display: "flex",
      justifyContent: "center"
    }),
    control: (base, state) => {
      return {
        ...base,
        backgroundColor: "#444445",
        borderRadius: "36px",
        padding: "8px"
      };
    },
    indicatorSeparator: (base, state) => ({
      ...base,
      display: "none"
    }),
    placeholder: (base, state) => ({
      ...base,
      textAlign: "center",
      color: "#fff",
      fontSize: "18px",
      fontFamily: "arial"
    }),
    singleValue: (base, state) => ({
      ...base,
      color: "#fff",
      textAlign: "center",
      fontSize: "18px"
    }),
    dropdownIndicator: (base, state) => ({
      ...base,
      color: "#000"
    })
  },
  dropdownIcon: {
    position: "absolute",
    zIndex: "999",
    left: "25px",
    top: "15px"
  },
  locationDropdownWrapper: {
    position: "relative"
  },
  exportButton: {
    width: "140px",
    fontSize: "20px"
  },
  promotionalOffersButton: {
    width: "200px",
    fontSize: "20px",
    marginLeft: "10px"
  },
  gymTagsButton: {
    width: "140px",
    fontSize: "20px",
    marginLeft: "10px"
  },
  migrateButton: {
    width: "230px",
    fontSize: "20px",
    marginLeft: "10px"
  }
};
